var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEidLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---My-identity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Identity-Header",
    transform: "translate(-217.000000, -22.000000)",
    fill: "#0057A0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-empowerid",
    transform: "translate(217.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2857143,7 L13.6387529,7 C16.9030426,7 18.8571429,8.91150333 18.8571429,12.1427955 C18.8571429,15.374211 16.9030426,17.2857143 13.6387529,17.2857143 L10.2857143,17.2857143 L10.2857143,7 Z M13.4432449,19.5176942 C18.5821349,19.5176942 21.5893052,16.7350599 21.5893052,11.9999089 C21.5893052,7.26487932 18.5821349,4.48206279 13.4432449,4.48206279 L8.95497266,4.48206279 C8.05728175,4.48206279 7.51871582,5.02074888 7.51871582,5.91831599 L7.51871582,18.0815017 C7.51871582,18.9791296 8.05728175,19.5176942 8.95497266,19.5176942 L13.4432449,19.5176942 Z M5.82693944,18.2161581 L5.82693944,5.78378118 C5.82693944,4.88615332 5.33321855,4.34758875 4.50285599,4.34758875 C3.65013166,4.34758875 3.15641078,4.88615332 3.15641078,5.78378118 L3.15641078,18.2161581 C3.15641078,19.1138467 3.65013166,19.6524113 4.50285599,19.6524113 C5.33321855,19.6524113 5.82693944,19.1138467 5.82693944,18.2161581 Z M19.1438525,0 C21.8258659,0 24,2.17412858 24,4.85613516 L24,19.1439256 C24,21.8258106 21.8258659,24 19.1438525,24 L4.85608669,24 C2.17413409,24 0,21.8258106 0,19.1439256 L0,4.85613516 C0,2.17412858 2.17413409,0 4.85608669,0 L19.1438525,0 Z",
    id: "Combined-Shape-Copy"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEidLogo);
export default __webpack_public_path__ + "static/media/eid-logo.74e26dee32f507081bbd527c677e22ef.svg";
export { ForwardRef as ReactComponent };